// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__9qZIJ","label":"CategoryService_label__3RoKW","location":"CategoryService_location__3FINN"};